import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { OfferFragment } from '@occc/graphql';
import { getPromptAtPumpOperations } from '@occc-app/routes/CampaignComponents/PromptAtPump/utils';
import { getOfferCustomDataOperation } from '@occc-app/offerHelpers/operations/getOfferCustomDataOperation';
import {
  getAwardRestrictionsOperations,
  getFulfillmentChannelConstraintOperations,
} from '@occc/feat-constraints';

import { getOfferNameAndDescriptionUpdateOperations } from '@occc-app/routes/Offer/components/OfferConfigureForm/utils/offerNameAndDescriptionUpdateOperations';
import { getOfferFulfillmentPriorityUpdateOperations } from '@occc-app/offerHelpers/operations/getOfferFulfillmentPriorityUpdateOperations';
import { getLimitsOperations, LimitType } from '@occc/feat-limits';
import { getEarningMechanismOperations } from './earningMechanismOperations';

import { ConfigureFormValues } from '../../../types';

type GetConfigureOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: ConfigureFormValues,
  dirtyFields: DirtyFieldsType,
) => Operation[];

export const getConfigureFormOperations: GetConfigureOperations = (
  offerId,
  offer,
  values,
  dirtyFields,
) => {
  const earningMechanismOperations = getEarningMechanismOperations(offerId, values, dirtyFields);
  const limitsOperations = getLimitsOperations(
    offerId,
    values.awardCount,
    dirtyFields,
    LimitType.AwardCount,
    { offer },
  );
  const promptAtPumpOperations = getPromptAtPumpOperations(offer, values, dirtyFields);

  const awardRestrictionsOperations = offer
    ? getAwardRestrictionsOperations({
        offer,
        values: values.awardRestrictions,
        dirtyFields,
      })
    : [];

  const fulfillmentChannelConstraintOperations = getFulfillmentChannelConstraintOperations(
    offerId,
    offer,
    values,
  );

  const additionalOperations: Operation[] = [];

  additionalOperations.push(
    ...getOfferNameAndDescriptionUpdateOperations(offerId, values, dirtyFields),
  );

  additionalOperations.push(
    ...getOfferFulfillmentPriorityUpdateOperations(offerId, values, dirtyFields),
  );

  const customDataOperation = getOfferCustomDataOperation({
    dirtyFields,
    values,
    offerId,
  });

  if (customDataOperation) {
    additionalOperations.push(customDataOperation);
  }

  return [
    ...additionalOperations,
    ...earningMechanismOperations,
    ...limitsOperations,
    ...promptAtPumpOperations,
    ...awardRestrictionsOperations,
    ...fulfillmentChannelConstraintOperations,
  ];
};
